import React from "react";
import {Link} from "react-router-dom";
import {Button, Typography} from "@material-tailwind/react";
import {CalendarCheck, CalendarIcon, Car, CheckCircle, MapPin, Wrench} from "lucide-react";
import dayjs from "dayjs";

function SummaryPanel({link, branch, selectedServiceList, dateList, selectedCar, carList, enabled}) {

    const getCarString = () => {
        for (let i = 0; i < carList.length; i++) {
            if (carList[i].eid === selectedCar) {
                return carList[i].make + " " + carList[i].model + " " + carList[i].year;
            }
        }
    };

    // Format dateList using dayjs
    const getFormattedDateTime = () => {
        if (!dateList) return "";
        // Assume dateList is in format "YYYY-MM-DD HH:mm"
        const [datePart, timePart] = dateList.split(" ");
        if (!datePart || !timePart) return dateList;
        const dateTime = dayjs(`${datePart} ${timePart}`);
        if (!dateTime.isValid()) return dateList;
        // Example: September 14, 2025 2:00 PM
        return dateTime.format("MM D, YYYY h:mm A");
    };

    return (
        <div className="lg:sticky lg:top-8">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 rounded-xl border border-gray-200">
                <div className="mb-4 sm:mb-6">
                    <div className="flex items-center gap-2 mb-2">
                        <MapPin className="w-4 h-4 sm:w-5 sm:h-5 "/>
                        <Typography variant="h6" color="blue-gray" className="font-bold text-base sm:text-lg">
                            Location
                        </Typography>
                    </div>
                    <Typography variant="h6" className="font-semibold text-blue-600 text-sm sm:text-base">
                        No.1 Jimmy Auto
                    </Typography>
                    <div className="flex items-center gap-1 mt-1">
                        <div className="text-xs sm:text-sm text-gray-600">
                            <div>{branch?.address}</div>
                            <div>{branch?.postalCode}</div>
                        </div>
                    </div>
                </div>

                <div className="mb-4 sm:mb-6">
                    <div className="flex items-center gap-2 mb-3 sm:mb-4">
                        <CheckCircle className="w-4 h-4 sm:w-5 sm:h-5"/>
                        <Typography variant="h6" color="blue-gray" className="font-semibold text-base sm:text-lg">
                            Selected Services
                        </Typography>
                    </div>

                    {selectedServiceList?.length === 0 ? (
                        <div className="space-y-2 sm:space-y-3 max-h-48 sm:max-h-64">
                            <div className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 shadow-sm">
                                <div className="flex-1 min-w-0 overflow-hidden">
                                    <Typography variant="small" color="gray"
                                                className="h-6 text-center text-xs sm:text-sm">
                                        No services selected yet
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-2 sm:space-y-3 max-h-48 sm:max-h-64 overflow-y-auto">
                            {selectedServiceList?.map((item, index) => (
                                <div key={index}
                                     className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
                                    <div
                                        className="w-6 h-6 sm:w-8 sm:h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                                        <Wrench className="w-3 h-3 sm:w-4 sm:h-4 text-blue-600"/>
                                    </div>
                                    <div className="flex-1 min-w-0 overflow-hidden">
                                        <Typography className="font-medium text-xs sm:text-sm leading-tight">
                                            {item.name}
                                        </Typography>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {dateList && (
                    <div className="mb-4 sm:mb-6">
                        <div className="flex items-center gap-2 mb-3 sm:mb-4">

                            <CalendarCheck className="w-4 h-4 sm:w-5 sm:h-5"/>
                            <Typography variant="h6" color="blue-gray" className="font-semibold text-base sm:text-lg">
                                Date & Time
                            </Typography>
                        </div>
                        <div className="space-y-2 sm:space-y-3">
                            <div
                                className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
                                <div
                                    className="w-6 h-6 sm:w-8 sm:h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <CalendarIcon className="w-3 h-3 sm:w-4 sm:h-4 text-green-600"/>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <Typography className="font-medium text-xs sm:text-sm">
                                        {getFormattedDateTime()}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {selectedCar && (

                    <div className="mb-4 sm:mb-6">
                        <div className="flex items-center gap-2 mb-3 sm:mb-4">

                            <Car className="w-4 h-4 sm:w-5 sm:h-5"/>
                            <Typography variant="h6" color="blue-gray" className="font-semibold text-base sm:text-lg">
                                My Car
                            </Typography>
                        </div>
                        <div className="space-y-2 sm:space-y-3">
                            <div
                                className="flex items-center gap-2 sm:gap-3 p-2 sm:p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
                                <div
                                    className="w-6 h-6 sm:w-8 sm:h-8 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
                                    <Car className="w-3 h-3 sm:w-4 sm:h-4 text-amber-600"/>
                                </div>
                                <div className="flex-1 min-w-0">
                                    <Typography className="font-medium text-xs sm:text-sm">
                                        {getCarString()}
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Desktop Next Button */}
                <div className="hidden lg:block">
                    {enabled ? (
                        <Link to={link}>
                            <Button
                                color="blue"
                                size="md"
                                fullWidth
                                className="py-4 text-md font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
                            >
                                Next Step →
                            </Button>
                        </Link>
                    ) : (
                        <Button
                            color="gray"
                            size="sm"
                            fullWidth
                            disabled
                            className="py-4 text-md"
                        >
                            Please select services
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SummaryPanel;
